<template>
  <div>
    <h1>Suggestions List</h1>
    <SuggestionItem v-for="suggestion in suggestions" :suggestion="suggestion" :key="suggestion.sug_id" :responding="responding" @reload="loadSuggestions"></SuggestionItem>
  </div>
</template>

<script>
import SuggestionItem from '@/components/SuggestionItem'

export default {
  name: 'Responses',

  components: {
    'SuggestionItem': SuggestionItem
  },

  data () {
    return {
      suggestions: null,
      url: process.env.VUE_APP_URL
    }
  },

  computed: {
    responding() {
      return this.$route.name === 'Write Responses'
    }
  },

  methods: {
    loadSuggestions() {
      this.$http
      .get(process.env.VUE_APP_URL + '/suggestions/token/' + this.$cookies.get('token'))
      .then(response => (
        this.suggestions = response.data
        ))
    }
  },

  mounted () {
    this.loadSuggestions();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
